//  Copyright (c) 2021 Comsearch, Inc., All rights reserved

// NOTE - argument must be an array which follows this pattern:
// module is the corresponding redux module. ie, "domain", "interferenceAnalysis" etc
// path allows you to point down to the specific set from within this module.
// eg ['domain', 'regulatory', 'bands'] points to the bands that are stored in redux.
// we toJS() these results so that the consumer need not know about ImmutableJS

const getTargetSetFromStore = ([module, ...path]) => (dispatch, getState) => (
  getState()[module].getIn(path).toJS()
)

export default getTargetSetFromStore
